<template>
  <div class="equityAction container" ref="equityAction">
    <div class="row">
      <div class="col-sm-8">
        <router-link :to="'/' + page">
          <i class="fas fa-times"></i> Hide this action
        </router-link>

        <h2>{{action.title}}</h2>
    
        <!-- ROW 1 -->
        <i :class="action.icon"></i> {{action.department}} 
        <i class="fas fa-calendar-alt timeline"></i> {{action.years_range}}    
        <i class="fas fa-map-marker neighborhood"></i> {{removeQuotes(removeBrackets(action.impacted_neighborhoods))}}
      
        <div>
          <h3>What We'll Deliver</h3>
          <ul>
            <li v-for="deliverable in action.major_deliverables" :key="deliverable">
              {{ deliverable }}
            </li>
          </ul>
        </div>
        <div>
          <h3>Our Strategies</h3>
          <span v-if="action.public_engagement">
            <p class="italicize">For Engaging the Community</p>
            <ul>
              <li v-for="engagement in action.public_engagement" :key="engagement">
                {{ engagement }}
              </li>
            </ul>
          </span>
          <span v-if="action.rsji_strategy || action.racial_equity_toolkit_planned ">
            <p class="italicize">For Race and Social Justice</p>
            <ul class="forrsji">
              <li v-if="action.rsji_strategy">{{removeQuotes(removeBrackets(action.rsji_strategy))}}</li>
              <li v-show="action.racial_equity_toolkit_planned">
                Create a racial equity toolkit
                <template v-if="action.ret_contact"> 
                  led by <a :href="'mailto:' + action.ret_contact">{{ action.ret_contact_name }}</a>
                </template>
              </li>
            </ul>
          </span>

        </div>
        <div>
          <h3>Outcomes We Want to Achieve</h3>
          <ul class="outcomes">
            <!-- <p>{{action.community_outcome_1_title}}</p> -->
            <li v-if="action.community_outcome_1">{{action.community_outcome_1.includes(': Other') ? action.outcome_1_other : action.community_outcome_1}}</li>
          </ul>
          <ul class="outcomes">
            <!-- <p>{{action.community_outcome_2_title}}</p> -->
            <li v-if="action.community_outcome_2">{{action.community_outcome_2.includes(': Other') ? action.outcome_2_other : action.community_outcome_2}}</li>
          </ul>
          <div v-if="action.outcome_measurement?.length > 0">
          <p class="italicize">How We'll Measure our Outcomes</p>
          <ul class="measurement" v-for="measurement in action.outcome_measurement" :key="measurement">
            <li>{{ measurement }}</li>
          </ul>
          <ul class="rsjiIndicatorList" v-if="rsjiIndicatorArrayList?.length > 0">
            <li><p>By evaluating the changes of {{rsjiIndicatorList}}</p></li>
          </ul>
          </div>
          

        </div>   
        </div> <!--left side -->
        <div class="rightSidebar col-sm-4"> 
          <div v-if="action.project_contact" class="contact">
            <h3>Contact</h3> 
            <a :href="'mailto:' + action.project_contact">{{action.project_contact_name}}</a>
          </div>
          <!-- <div v-if="action.webpage || rsjiIndicatorArrayList" class="relatedLinks"> -->
          <div v-if="action.webpage" class="relatedLinks">
            <h3>Related Links</h3>
            <ul class="relatedLinks"> 
              <li v-if="action.webpage"><a :href="action.webpage.url">{{action.webpage_title || "Program Website"}}</a></li>
        
              <!-- Hiding until program pages are launched -->
              <!-- <template v-for="indicator in rsjiIndicatorArrayList" :key="indicator">
                  <li><a :href=rsjiIndicators[indicator]>{{indicator}}</a></li>
              </template>     -->
            </ul>
        
          </div>
      </div> <!--right side -->
    </div>   
  </div>
</template>

<script>
export default {
  name: "EquityAction",
  data() {
    return {
      rsjiIndicators :{
        'Race & Ethnicity': 'https://www.seattle.gov/rsji/racial-equity-research/racial-demographics',
        'Near-Poverty Income': 'https://www.seattle.gov/rsji/racial-equity-research/poverty',
        'Homeownership': 'https://www.seattle.gov/rsji/racial-equity-research/community-wealth',
        'Housing Cost Burden': 'https://www.seattle.gov/rsji/racial-equity-research/housing-affordability',
        'Food insecurity': 'https://www.seattle.gov/rsji/racial-equity-research/food-insecurity',
        'Medical Care Accessibility': 'https://www.seattle.gov/rsji/racial-equity-research/health-disparities',
        'Youth Mental Health': 'https://www.seattle.gov/rsji/racial-equity-research/youth-wellbeing',
        'Diabetes': 'https://www.seattle.gov/rsji/racial-equity-research/health-disparities',
        'Community Cultural Space': 'https://www.seattle.gov',
        'Life Expectancy at Birth': 'https://www.seattle.gov',
        'Population Density': 'https://www.seattle.gov',
        'Gender': 'https://www.seattle.gov',
        'Age': 'https://www.seattle.gov',
        'Voter Turnout': 'https://www.seattle.gov',
        'Public Libraries': 'https://www.seattle.gov',
        'Community Centers': 'https://www.seattle.gov',
        'Healthy Food Access': 'https://www.seattle.gov/rsji/racial-equity-research/food-insecurity',
        'Internet Access': 'https://www.seattle.gov',
        'Sidewalks': 'https://www.seattle.gov',
        'Public Transit': 'https://www.seattle.gov',
        'Commute Time': 'https://www.seattle.gov',
        'Math Proficiency': 'https://www.seattle.gov',
        'School Discipline': 'https://www.seattle.gov',
        'Educational Attainment': 'https://www.seattle.gov',
        'High School Graduation': 'https://www.seattle.gov',
        'Tree Canopy': 'https://www.seattle.gov',
        'Air Pollution Exposure': 'https://www.seattle.gov',
        'Parks & Open Space': 'https://www.seattle.gov',
        'Disability': 'https://www.seattle.gov',
        'Terry Stops by Police': 'https://www.seattle.gov',
        'Misdemeanor Charges': 'https://www.seattle.gov',
        'Juvenile Detention': 'https://www.seattle.gov',
        'Incarceration': 'https://www.seattle.gov',
        'Anti-racist Multicultural Organization Continuum': 'https://www.seattle.gov',
        'Relational Culture at The Workplace': 'https://www.seattle.gov',
      },
    }
  },
  props: {
    id: String,
    actions: Array,
    filters: Object,
    page: {
      type: Number,
      default: 1
    }
  },
  mounted() {
    this.updateHeight()
    this.scrollToAction()
  },
  updated() {
    this.updateHeight()
    this.scrollToAction()
  },
  methods:{
    updateHeight() {
      const height = this.$refs.equityAction.clientHeight

      this.$emit('heightChanged', height)
    },
    scrollToAction() {
      this.$refs.equityAction.scrollIntoView({
        behavior: 'smooth'
      });
    },
    removeBrackets : function(stringWithBrackets){
      stringWithBrackets = stringWithBrackets?.replace(/\[|\]/g, '');
      return stringWithBrackets;
    },
    removeQuotes : function(stringWithQuotes){
      stringWithQuotes = stringWithQuotes?.replace(/"|#/g, '');
      return stringWithQuotes;
    },
    removeNumbers : function(stringWithNumbers){
      stringWithNumbers = stringWithNumbers?.replace("1)", '').replace("2)",'').replace("3)",'').replace("4)",'').replace("5)",'');
      stringWithNumbers = stringWithNumbers?.replace("6)", '').replace("7)",'').replace("8)",'').replace("9)",'').replace("10)",'');
      return stringWithNumbers;
    },
    splitToArrayList : function(ind){
      return ind.split(',');
    }
  },
 computed:{
    action() {
      let id = this.id

      let action = this.actions.filter(x => x.id == id)

      return (action.length > 0) ? action[0] : null
    },
    trimRsjiIndicator() {
      let trimRsjiIndicator = this.action.rsj_indicators?.trim()
      let otherIndicator = this.action.rsj_other || null

      // Replace "Other" with action.rsj_other OR remove it entirely
      if (otherIndicator) {
        trimRsjiIndicator = trimRsjiIndicator?.replace(/"Other"/g, otherIndicator);
      } else {
        trimRsjiIndicator = trimRsjiIndicator?.replace(/,"Other"|"Other",|"Other"/g, '');
      }


      // Strip square brackets
      trimRsjiIndicator = trimRsjiIndicator?.replace(/\[|\]/g, '');
      // Strip quotes, periods
      trimRsjiIndicator = trimRsjiIndicator?.replace(/"|\./g, '');
      // Replace ;# delimiter
      trimRsjiIndicator = trimRsjiIndicator?.replace(/;#/g, ',');

      return (trimRsjiIndicator !== "") ? trimRsjiIndicator : null;
    },
    rsjiIndicatorArrayList(){
      return this.trimRsjiIndicator?.split(',');   
    },  
    rsjiIndicatorList(){
      //find the last item and append ' and'
      var appended =this.trimRsjiIndicator.toLowerCase()?.replace(/,/g, ', ');
      appended = appended.replace(/,([^,]*)$/, ', and $1');         
      return appended;
    },   
 }

};
</script>

<style scoped lang="scss">
  .equityAction {
    padding: 40px 0;
  }

  a {
    font-weight: bold;
  }

  .italicize{
    font-style: italic;
  }
  svg:not(.fa-times){
    color: #007749;
  }
  .timeline, .neighborhood{
    margin-left: 12px;
  }
  .contact, .relatedLinks{
    padding: 10px;
    background-color: #f1f1f1;
  }

  li {
    list-style-type: disc;
    margin-left: -20px;
  }
  .relatedLinks ul li{
    margin-bottom: 10px;
    margin-left: 20px;
    list-style-type:square;
  }
</style>
